import React from 'react';
import '../styles/components.css';

const TransparencyPage = () => {
    return (
        <div className="page-container">
            <div className="transparency-page" style={{ maxWidth: '900px', margin: '0 auto' }}>
                <div className="page-header">
                    <h2>Simply Transparent</h2>
                    <p>We believe an educated customer is our best customer.</p>
                </div>

                {/* Section 1: Pricing */}
                <div className="card-container" style={{ marginBottom: '30px' }}>
                    <h3 style={{ color: '#b8860b', marginBottom: '15px' }}>💰 How We Calculate Price</h3>
                    <p>We follow a standard, transparent formula for all our jewellery:</p>
                    <div className="price-formula" style={{ background: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px dashed #ccc', marginTop: '15px', fontFamily: 'monospace', fontSize: '1.1rem' }}>
                        (Gold Rate x Weight) + Making Charges + GST (3%)
                    </div>
                    <ul style={{ marginTop: '15px', paddingLeft: '20px', lineHeight: '1.8' }}>
                        <li><strong>Gold Rate:</strong> The live market rate for 22K (916) gold.</li>
                        <li><strong>Making Charges:</strong> Labour cost for our skilled Karigars (starts from 8%).</li>
                        <li><strong>GST:</strong> Mandatory 3% government tax.</li>
                    </ul>
                </div>

                {/* Section 2: Hallmark */}
                <div className="card-container" style={{ marginBottom: '30px' }}>
                    <h3 style={{ color: '#b8860b', marginBottom: '15px' }}>🏆 100% BIS Hallmarked</h3>
                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                        <div style={{ flex: 1, minWidth: '300px' }}>
                            <p>Every single piece at MAB Jewels comes with a <strong>6-digit Alphanumeric HUID code</strong>.</p>
                            <p>This guarantees:</p>
                            <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                                <li>The purity (22K/916) is lab-tested.</li>
                                <li>You can trace the item using the BIS Care App.</li>
                                <li>We offer a Buyback Guarantee on gold value.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Section 3: Care */}
                <div className="card-container">
                    <h3 style={{ color: '#b8860b', marginBottom: '15px' }}>✨ Jewellery Care Guide</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                        <div className="care-card" style={{ background: '#fffcf5', padding: '15px', borderRadius: '8px' }}>
                            <h4>Store Separately</h4>
                            <p style={{ fontSize: '0.9rem' }}>Keep pieces in individual pouches to avoid scratches.</p>
                        </div>
                        <div className="care-card" style={{ background: '#fffcf5', padding: '15px', borderRadius: '8px' }}>
                            <h4>Avoid Chemicals</h4>
                            <p style={{ fontSize: '0.9rem' }}>Keep away from perfumes, sprays, and cleaning agents.</p>
                        </div>
                        <div className="care-card" style={{ background: '#fffcf5', padding: '15px', borderRadius: '8px' }}>
                            <h4>Clean Gently</h4>
                            <p style={{ fontSize: '0.9rem' }}>Use mild soap solution and a soft brush for cleaning.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransparencyPage;
